import React from 'react'
import styles from './SegmentationBoxInfo.module.css'

type SegmentationBoxHeaderProps = {
  backgroundImage: string
  height: number
}

export const SegmentationBoxHeader = ({ backgroundImage, height }: SegmentationBoxHeaderProps) => {
  return (
    <div className={styles.header}>
      {backgroundImage && (
        <img alt='' className={styles.headerImage} data-header-height={height} src={backgroundImage} />
      )}
    </div>
  )
}
